"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.PrevNextButton = exports.PlayPauseButton = exports.DotsNavigation = exports.StageItem = exports.SlideInfo = void 0;

var SlideInfo_1 = require("./SlideInfo");

Object.defineProperty(exports, "SlideInfo", {
  enumerable: !0,
  get: function get() {
    return SlideInfo_1.SlideInfo;
  }
});

var StageItem_1 = require("./StageItem");

Object.defineProperty(exports, "StageItem", {
  enumerable: !0,
  get: function get() {
    return StageItem_1.StageItem;
  }
});

var DotsNavigation_1 = require("./DotsNavigation");

Object.defineProperty(exports, "DotsNavigation", {
  enumerable: !0,
  get: function get() {
    return DotsNavigation_1.DotsNavigation;
  }
});

var PlayPauseButton_1 = require("./PlayPauseButton");

Object.defineProperty(exports, "PlayPauseButton", {
  enumerable: !0,
  get: function get() {
    return PlayPauseButton_1.PlayPauseButton;
  }
});

var PrevNextButton_1 = require("./PrevNextButton");

Object.defineProperty(exports, "PrevNextButton", {
  enumerable: !0,
  get: function get() {
    return PrevNextButton_1.PrevNextButton;
  }
});